import { InternalKeyword, KeywordMutation } from '../features/keywords/types/InternalKeyword'
import { internalApiserverApi } from './internal-apiserver'

const keywordsApi = internalApiserverApi.enhanceEndpoints({ addTagTypes: ['keywords', 'languageMaps'] }).injectEndpoints({
  endpoints: (builder) => ({
    getInternalKeywords: builder.query<InternalKeyword[], void>({
      query: () => 'i/keywords/list/feature',
      providesTags: ['keywords'],
    }),
    saveKeyword: builder.mutation<InternalKeyword, KeywordMutation>({
      query: (keyword) => ({ url: 'i/keywords', method: 'POST', body: keyword }),
      invalidatesTags: ['keywords', 'languageMaps'],
    }),
    deleteKeyword: builder.mutation<void, string>({
      query: (id) => ({ url: `i/keywords/${id}`, method: 'DELETE' }),
      invalidatesTags: ['keywords'],
    }),
  }),
})

export const { useGetInternalKeywordsQuery, useSaveKeywordMutation, useDeleteKeywordMutation } = keywordsApi
